module.exports = window["__sharedEmotionStyled"];